import { privateApi } from 'services';
import { JobGroup } from './types';

const fetchJobGroup = async (jobGroupId: string): Promise<JobGroup> =>
    privateApi.get<JobGroup>(`job-groups/${jobGroupId}`);

export const JobGroupGateway = {
    fetchJobGroup,
};
